import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { breadcrumbAction } from "../../redux/actions/config.action";
import { getMerchantAccountDetails } from "../../redux/actions/merchant-account.action";
import { getMerchantKey, regenerateMerchantKey } from "../../redux/actions/merchant/integration.action";
import InputField from "../../components/formControl/input/InputField";
import SvgIcon from "../../components/Images/SvgIcon";
import { showToast } from "../../lib/global";

const IntegrationMerchant = () => {
    const dispatch = useDispatch();
    const [storeId, setStoreId] = useState("");
    const [appKey, setAppKey] = useState("");
    const [showKey, setShowKey] = useState(false);

    useEffect(() => {
        const breadcrumb = [
            { label: "Setting", url: null },
            { label: "Integration", url: null }
        ];
        dispatch(breadcrumbAction(breadcrumb));

        dispatch(getMerchantAccountDetails()).then((response) => {
            const sid = response?.data?.data?.storeId;
            if (sid) {
                setStoreId(sid);
                fetchKey(sid);
            }
        });
    }, [dispatch]);

    const fetchKey = (sid) => {
        dispatch(getMerchantKey(sid)).then((response) => {
            if (response?.data?.status === 200) {
                setAppKey(response?.data?.data?.appKey || "");
            }
        });
    };

    const handleRegenerate = () => {
        if (window.confirm("Are you sure you want to regenerate the App Key? The old key will no longer work.")) {
            dispatch(regenerateMerchantKey()).then((response) => {
                if (response?.data?.status === 200) {
                    setAppKey(response?.data?.data?.appKey || "");
                    showToast("App Key regenerated successfully", "success");
                } else {
                    showToast(response?.data?.message || "Failed to regenerate App Key", "error");
                }
            });
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        showToast("Copied to clipboard", "success");
    };

    return (
        <div className="container-fluid">
            <div className="card p-4">
                <h5 className="mb-4">Information</h5>
                
                <div className="form-group mb-4">
                    <label className="text-muted mb-2">Store ID</label>
                    <div className="d-flex align-items-center">
                        <InputField
                            type="text"
                            value={storeId}
                            readOnly
                            formClass="flex-grow-1"
                            inputClass="bg-light"
                        />
                        <button 
                            className="btn btn-outline-secondary ml-2"
                            onClick={() => handleCopy(storeId)}
                            title="Copy Store ID"
                        >
                            <SvgIcon src="/icons/duplicate.svg" style={{ width: '18px' }} />
                        </button>
                    </div>
                </div>

                <div className="form-group mb-4">
                    <label className="text-muted mb-2">App Key</label>
                    <div className="d-flex align-items-center">
                        <InputField
                            type={showKey ? "text" : "password"}
                            value={appKey}
                            readOnly
                            formClass="flex-grow-1"
                            inputClass="bg-light"
                        />
                        <div className="d-flex ml-2">
                            <button 
                                className="btn btn-outline-secondary mr-2"
                                onClick={() => setShowKey(!showKey)}
                                title={showKey ? "Hide" : "Show"}
                            >
                                <SvgIcon src="/icons/view_icon.svg" style={{ width: '18px' }} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary mr-2"
                                onClick={() => handleCopy(appKey)}
                                title="Copy"
                            >
                                <SvgIcon src="/icons/duplicate.svg" style={{ width: '18px' }} />
                            </button>
                            <button 
                                className="btn btn-outline-danger"
                                onClick={handleRegenerate}
                                title="Regenerate"
                            >
                                <img src="/icons/Refresh_live.png" alt="refresh" style={{ width: '18px' }} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntegrationMerchant;
